import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import styles from "./MobAttackArea.module.scss"
import { IMobAttackAreaProps } from "./types"

const MobAttackAreaComponent: FC<IMobAttackAreaProps> = ({ action }) => {
  const { t } = useTranslation("mobs")

  return (
    <section className={styles.MobAttackArea} aria-busy={action.busy}>
      {action.kind === "attack" ? (
        <>
          <button
            type="button"
            className={styles.MobAttackArea_button}
            disabled={!action.enabled}
            onClick={action.onAttack}
          >
            {t("card.attack")}
          </button>
          {action.devWin && (
            <button
              type="button"
              className={styles.MobAttackArea_button}
              disabled={!action.devWin.enabled}
              onClick={action.devWin.onDevWin}
            >
              {t("card.devWin")}
            </button>
          )}
        </>
      ) : (
        <button
          type="button"
          className={styles.MobAttackArea_button}
          disabled={action.busy}
          onClick={action.onLeave}
        >
          {t("card.leaveStale")}
        </button>
      )}
      {action.hintKey && (
        <span className={styles.MobAttackArea_hint}>{t(action.hintKey)}</span>
      )}
    </section>
  )
}

export const MobAttackArea = memo(MobAttackAreaComponent)
